"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionExportHighchartsButton = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const AppPubSub_1 = require("src/hello_assets/src/util/PubSub/AppPubSub");
const HighchartsWithOptionsComponent_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsWithOptionsComponent");
const lodash_1 = __importDefault(require("lodash"));
const HeaderExportHighchartsButton_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/highcharts/HeaderExportHighchartsButton");
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const RetentionPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionPageDataProvider");
const RetentionHighchartsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/state/data/RetentionHighchartsComponent");
const RetentionExportHighchartsButton = () => {
    var _a;
    const { state: { status, error, data } } = (0, RetentionPageDataProvider_1.useRetentionPageDataContext)();
    const highchartsOptionsContext = (0, HighchartsOptionsProvider_1.useHighchartsOptionsContext)();
    const onClickExportHighcharts = (0, react_1.useCallback)(() => {
        AppPubSub_1.AppPubSub.publish(HighchartsWithOptionsComponent_1.PubSubAction_ExportHighcharts, { chartIdentifier: RetentionHighchartsComponent_1.retentionChartIdentifier });
    }, []);
    const chartHasNoData = ((_a = highchartsOptionsContext.state.chartStatus) === null || _a === void 0 ? void 0 : _a.status) === "noData";
    const disabled = status.inProgress || highchartsOptionsContext.state.error.isError || lodash_1.default.isNil(data) || chartHasNoData;
    return React.createElement(HeaderExportHighchartsButton_1.HeaderExportHighchartsButton, { onClick: onClickExportHighcharts, disabled: disabled });
};
exports.RetentionExportHighchartsButton = RetentionExportHighchartsButton;
